import { SIGNOL_COLOURS } from "@signolteam/shared/colours";

/** if your component uses a hex code colour
 *
 * @param {"hex"|"name-with-shade"} valueType if option.value should be hex (eg #000000) or name (eg primary-500)
 * @example
 * bgColor: {
 *   propType: PropTypes.string,
 *   controlType: "select",
 *   options: selectOptionsAllColourHexCodes([300]),
 * }
 */
export function selectOptionsAllColourHexCodes(
  limitShades = [],
  valueType = "hex",
) {
  const palette = SIGNOL_COLOURS;
  const options = {};

  for (const [colorName, value] of Object.entries(palette)) {
    if (typeof value === "string") {
      // No shade, always include
      options[colorName] = value;
    } else {
      // Has shades
      for (const [shade, hex] of Object.entries(value)) {
        if (limitShades.length === 0 || limitShades.includes(Number(shade))) {
          const label = `${colorName}-${shade}`;
          const value = valueType === "name-with-shade" ? label : hex;
          options[label] = value;
        }
      }
    }
  }

  return options;
}
